module.exports = __webpack_public_path__ + "img/brown-carpet-grass-04.3261f6f0.png";